export default __webpack_public_path__ + "static/media/tc.5ad06c89.svg";